<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import IncidentLevel from "@dashboard/base/IncidentLevel";
import TrustSiteApiService from "@dashboard/ajax/TrustSiteApiService";
import type { Incident } from "@entity/Incident";
import { generateIncidentLabelId, useIncidentSelection } from "@composable/useIncidentSelection";

defineOptions({
  inheritAttrs: false,
});

interface Props {
  incident: Incident;
  index: number;
}

const props = defineProps<Props>();
const { t } = useI18n();

const labelIndex = props.index;
const labelId = computed(() => generateIncidentLabelId(props.incident.service, props.incident.region, props.incident.id));
const levelClass = computed(() => IncidentLevel.classname(props.incident.level));
const rowClass = `warn-row-${Math.trunc(labelIndex / 4 + 1)}`;

const { selected, toggleSelected } = useIncidentSelection({
  index: props.index,
  labelAnchorId: labelId,
  labelInstanceId: labelIndex,
});

const logged = TrustSiteApiService.isLoggedIn();
</script>

<template>
  <div
    :id="labelId"
    class="warning-label flex align-center CId-incident-label IId-incident-label"
    :class="[rowClass, { reveal: selected }]"
    data-dtm-element="incident-label"
    :data-dtm-name="`service-${labelId}`"
    @click.prevent="toggleSelected"
  >
    <div class="have-info-wrapper down medium" :class="levelClass">
      <div class="have-info-icon" />
    </div>
    <span class="warning-name">{{ t(props.incident.service) }}</span>
    <span v-if="!logged" class="location-lbl">{{ t(props.incident.region) }}</span>
    <span class="close-lbl" />
  </div>
</template>
